import React from 'react'

const Analytics = () => {
  return (
    <div>
      <h1>
      this is Analytics </h1>
    </div>
  )
}

export default Analytics
